import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
// import colors from "vuetify/lib/util/colors";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#555",
        secondary: "#b0bec5",
        accent: "#00a95c",
        error: "#b71c1c",
      },
    },
  },
});
